<!-- 权责清单登录页 -->
<template>
    <div class="login">
        <video class="login-video-bg" src="../assets/login.mp4" autoplay="autoplay" muted="muted" loop="loop"></video>
        <div class="login-form-panel">
            <div class="login-form-header">
                <div class="login-form-logo">
                    <!-- <img src="../assets/logo20.png" alt=""> -->
                    <img src="../assets/nlogo.png" alt="">
                </div>
                <div class="login-form-title">让权力在阳光下行使</div>
            </div>
            <div class="login-form-content">
                <div class="login-form-tabs">
                    用户登录
                </div>
                <div class="login-form-container">
                    <Form ref="FormInline" :model="FormInline" :rules="RuleInline"
                        @keyup.enter.native="submitLogin('FormInline')">
                        <FormItem prop="user">
                            <i class="login-icon login-icon-user"></i>
                            <Input type="text" v-model="FormInline.user" placeholder="请输入账号">
                            <!-- <Icon type="ios-person-outline" slot="prepend"></Icon> -->
                            </Input>
                        </FormItem>
                        <FormItem prop="password">
                            <i class="login-icon login-icon-password"></i>
                            <Input type="password" v-model="FormInline.password" placeholder="请输入密码">
                            <!-- <Icon type="ios-lock-outline" slot="prepend"></Icon> -->
                            </Input>
                        </FormItem>
                        <p class="tips">如无账号，请致电 13911386635，免费获取测试账号</p>
                        <FormItem class="login-form-btn">
                            <Button type="primary" @click="submitLogin('FormInline')">登录</Button>
                        </FormItem>
                    </Form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { login, regist } from "@/api/index";
    export default {
        name: 'Login',
        components: {

        },
        data() {
            return {
                FormInline: {
                    user: '',
                    password: ''
                },
                RuleInline: {
                    user: [
                        { required: true, message: '请输入账号', trigger: 'blur' }
                    ],
                    password: [
                        { required: true, message: '请输入密码', trigger: 'blur' },
                        { type: 'string', min: 6, message: '密码长度不能小于6位', trigger: 'blur' }
                    ]
                }
            }
        },
        computed: {

        },
        watch: {

        },
        created() {

        },
        mounted() {

        },
        destoryed() {

        },
        methods: {
            submitLogin(name) {
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        // 登录
                        login({
                            phoneNum: this.FormInline.user,
                            passWord: this.FormInline.password
                        }).then(res => {
                            if (res.code === 0) {
                                this.setStore('Authorization', res.data.token);
                                this.setStore('UserMes', res.data);
                                this.$Message.success('登录成功!');
                                this.$router.push({ path: '/accrual' });
                            }
                        });

                        // 注册
                        // regist({
                        //   phoneNum: this.FormInline.user,
                        //   passWord: this.FormInline.password
                        // }).then(res => {
                        //   if (res.code === 0) {
                        //     this.$Message.success('注册成功!');
                        //   }
                        // });
                    } else {
                        this.$Message.error('登录失败!');
                    }
                })
            }
        },
        filter: {

        }
    }
</script>

<style scoped>
    .login-video-bg {
        overflow: hidden;
        position: fixed;
        top: 50%;
        left: 50%;
        min-width: 100%;
        min-height: 100%;
        width: auto;
        height: auto;
        transform: translateX(-50%) translateY(-50%);
    }

    .login-form-panel {
        display: flex;
        flex-direction: column;
        justify-content: center;
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        z-index: 2;
        margin: auto;
        /* padding-left: 80px; */
        padding: 50px 48px 86px;
        width: 470px;
        height: 562px;
        /* height: 52%; */
        border-radius: 3px;
        background-color: rgba(9, 18, 43, 0.3);
        /* background: linear-gradient(to bottom, rgba(31, 54, 82, 0.3), rgba(151, 177, 177, 0.3) 40%, rgba(195, 175, 138, 0.3) 50%, rgba(27, 32, 43, 0.3) 60%, rgba(63, 80, 107, 0.3)); */
    }

    .login-form-header {
        flex: 1 1 auto;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        padding-bottom: 72px;
        font-size: 32px;
        /* font-weight: bolder; */
        color: #fff;
    }

    .login-form-logo {
        margin-top: 50px;
        width: 50%;
    }

    .login-form-logo img {
        width: 100%;
    }

    .login-form-content {
        flex: 2 1 auto;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        /* padding-top: 60px; */
    }

    .login-form-tabs {
        color: #fff;
        font-size: 18px;
        margin-bottom: 26px;
        /* margin: 8px 0; */
    }

    .ivu-btn-default,
    .ivu-input-wrapper {
        width: 100%;
    }

    ::-webkit-input-placeholder {
        color: #fff;
    }

    ::-moz-placeholder {
        color: #fff;
    }

    :-ms-input-placeholder {
        color: #fff;
    }

    .login-icon {
        display: inline-block;
        position: absolute;
        top: 15px;
        left: 8px;
        z-index: 1;
        width: 18px;
        height: 18px;

    }

    .login-icon-user {
        background: url(../assets/icon-user.png) no-repeat center center;
    }

    .login-icon-password {
        background: url(../assets/icon-password.png) no-repeat center center;
    }
    .tips {
      margin: 28px 0 14px;
      font-size: 14px;
      text-align: center;
      color: #f00;
    }
</style>